/* global verifySeal */

/**
 * Make GoDaddy siteseal keyboard accessible
 */
function makeGodaddySealAccessible() {
    var sealImg = document.querySelector('#siteseal img[onclick*="verifySeal"]');
    if (sealImg && !sealImg.hasAttribute('data-accessible')) {
        sealImg.setAttribute('tabindex', '0');
        sealImg.setAttribute('role', 'button');
        sealImg.setAttribute('aria-label', 'Verify SSL certificate');
        sealImg.setAttribute('data-accessible', 'true');
        sealImg.addEventListener('keypress', function(e) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                if (typeof verifySeal === 'function') {
                    verifySeal();
                }
            }
        });
    }
}

/**
 * Make Trust Guard seal keyboard accessible
 */
function makeTrustGuardSealAccessible() {
    var trustLink = document.querySelector('a[href*="secure.trust-guard.com/business"]');
    if (trustLink && !trustLink.hasAttribute('data-accessible')) {
        // Add keyboard support for the onclick handler
        trustLink.addEventListener('keypress', function(e) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                // Trigger the onclick handler logic
                var nonwin = navigator.appName !== 'Microsoft Internet Explorer' ? 'yes' : 'no';
                window.open(this.href, 'welcome', 'location=' + nonwin + ',scrollbars=yes,width=517,height=' + screen.availHeight + ',menubar=no,toolbar=no');
            }
        });
        trustLink.setAttribute('data-accessible', 'true');
    }
}

/**
 * Initialize seal accessibility on page load
 */
document.addEventListener('DOMContentLoaded', function() {
    makeGodaddySealAccessible();
    makeTrustGuardSealAccessible();
});

/**
 * Watch for dynamic injection by GoDaddy script
 */
var sealContainer = document.getElementById('siteseal');
if (sealContainer) {
    var sealObserver = new MutationObserver(function() {
        makeGodaddySealAccessible();
    });
    sealObserver.observe(sealContainer, { childList: true, subtree: true });
}

/**
 * Watch for dynamic injection of Trust Guard seal
 */
var footerContainer = document.querySelector('footer');
if (footerContainer) {
    var footerObserver = new MutationObserver(function() {
        makeTrustGuardSealAccessible();
    });
    footerObserver.observe(footerContainer, { childList: true, subtree: true });
}
